"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.atCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var atCountry = exports.atCountry = function atCountry(t) {
  return {
    id: 'AT',
    name: t('Austria'),
    flag: '🇦🇹',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1010 or 6020',
    phonePrefix: '43',
    phoneLength: 10,
    pricingVersion: 14,
    timezone: 'Europe/Vienna',
    currency: 'EUR'
  };
};